// @ts-nocheck
import React from "react";
import { FILES_URL } from "includes/paths";
import "./PostVideos.css";

export default function PostVideos({ videos }) {
	if (!videos?.length) return null;

	function getVideoUrl(video) {
		if (video.previewUrl) return video.previewUrl;
		if (video.urlOrigin) {
			if (video.urlOrigin.startsWith("http")) return video.urlOrigin;
			return FILES_URL + video.urlOrigin;
		}
		if (video.filePath) {
			if (video.filePath.startsWith("http")) return video.filePath;
			return FILES_URL + video.filePath;
		}
		return null;
	}

	return (
		<div className="PostVideos">
			{videos.map((video, i) => {
				const url = getVideoUrl(video);
				if (!url) return null;
				return (
					<video
						key={video.documentId || i}
						className="post-video-player"
						controls
						preload="metadata"
					>
						<source src={url} />
					</video>
				);
			})}
		</div>
	);
}
